// export function generateTitle(title) {

//     const hasKeyR = this.$te('route.'+title)
//     if (hasKeyR) {
//         const translatedTitle = this.$t('route.'+title)
//         return translatedTitle
//     }

//     const hasKeyP = this.$te('page.'+title)
//     if (hasKeyP) {
//         const translatedTitle2 = this.$t('page.'+title)
//         return translatedTitle2
//     }

//     return title
// }

// export function generateTitle_I(title, vueInstance) {

//     const hasKeyR = vueInstance.$te('route.'+title)
//     if (hasKeyR) {
//         const translatedTitle = vueInstance.$t('route.'+title)
//         return translatedTitle
//     }

//     const hasKeyP = vueInstance.$te('page.'+title)
//     if (hasKeyP) {
//         const translatedTitle2 = vueInstance.$t('page.'+title)
//         return translatedTitle2
//     }

//     return title
// }

let i18nInstance = null;
/**
 * ��ʼ�� i18n Helper������ Vue ʵ���� I18n ʵ��
 * ������ main.js �� Vue ��ʵ����������������
 * @param {Object} instance - Vue ʵ�� (this) �� I18n ʵ�� (this.$i18n)
 */
export function initI18n(instance) {
    if (!instance) {
        console.error('Failed to initialize i18nHelper: instance is null or undefined.');
        return;
    }
    
    // ���жϴ������ Vue ʵ������ I18n ʵ��
    // Vue ʵ��ͨ���� $options ���ԣ�I18n ʵ��ͨ���� locale ����
    if (instance.$options || instance.$t) { 
        // �������� Vue ʵ����ʹ�� $t, $te
        i18nInstance = {
            t: instance.$t.bind(instance), // bind ȷ�� this ��������ȷ
            te: instance.$te.bind(instance)
        };
    } else if (instance.t || instance.te) {
        // �������� I18n ʵ����ֱ��ʹ�� t, te
        i18nInstance = {
            t: instance.t.bind(instance),
            te: instance.te.bind(instance)
        };
    } else {
        console.error('Failed to initialize i18nHelper: unrecognized instance type.', instance);
        i18nInstance = null;
    }

    if (i18nInstance) {
        console.log('i18nHelper initialized successfully.');
    }
}

export function generateTitle(title) {
    if (!i18nInstance) {
        console.warn('i18nHelper is not initialized. Returning original title.');
        return title;
    }

    try {
        const fullRouteKey = 'route.' + title;
        if (i18nInstance.te(fullRouteKey)) {
            return i18nInstance.t(fullRouteKey);
        }

        const fullPageKey = 'page.' + title;
        if (i18nInstance.te(fullPageKey)) {
            return i18nInstance.t(fullPageKey);
        }
    } catch (error) {
        console.error('Error occurred during translation in generateTitle:', error);
    }

    return title; // Fallback
}